<template>
  <footer class="main-footer">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-12">
          <div class="main-footer__top">
            <span class="main-footer__top-subscribe">
              SUBSCRIBE TO OUR
            </span>
            <div class="main-footer__top-newsletter">
              <span class="main-footer__top-newsletter-title">
                {{ "app.ui.news" | trans }}
              </span>
              <span class="main-footer__top-newsletter-subtitle">
                {{ "app.ui.letter" | trans }}
              </span>
            </div>
            <form
              action=""
              method="post"
              class="main-footer__top-newsletter-form"
            >
              <div class="form input-group">
                <div>
                  <input
                    type="email"
                    id="identifier"
                    name="identifier"
                    required="required"
                    class="form-control"
                    aria-describedby="addon-665385056"
                    placeholder="Adresă e-mail"
                  />
                </div>
                <div class="input-group-append">
                  <button
                    class="btn btn-default"
                    type="submit"
                    id="addon-665385056"
                    aria-label="Înscrie-te în lista Patronos"
                  >
                    <svg
                      width="38"
                      height="38"
                      viewBox="0 0 38 38"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M37.8986 18.5663L36.7187 19.7463L36.5832 19.8817L19.4353 37.0297L17.575 35.1694L32.8627 19.8817H0.961426V17.2509H32.8627L17.575 1.96326L19.4353 0.103027L36.5832 17.2509L36.7187 17.3864L37.8986 18.5663Z"
                        fill="white"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-2 col-12" v-for="item in footerMenu" :key="item.id">
          <div
            :id="item.id"
            class="footer-menu"
            :class="{ active: isActive === String(item.id) }"
            @click="toggleMenu"
          >
            <h5 class="footer-menu-title">{{ item.label }}</h5>
            <ul class="footer-menu-list" v-if="item.items.length">
              <li
                class="footer-menu-item"
                v-for="subItem in item.items"
                :key="subItem.id"
              >
                <a
                  :href="subItem.url"
                  v-if="subItem.url"
                  v-html="subItem.label"
                >
                </a>
                <span v-else v-html="subItem.label"></span>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <h2 class="footer-menu-title contact-us">
            {{ "sylius.ui.contact_us" | trans }}
          </h2>
          <div class="footer-contacts">
            <app-phone-icon />
            <div class="footer-contacts-details">
              <a class="footer-contacts-phone" href="tel:+4 031 225 25 25">
                {{ "footer.phone_number" | trans }}
              </a>
              <span class="footer-contacts-working-hours">
                {{ "footer.work_program" | trans }}
              </span>
            </div>
          </div>
          <div class="footer-socials">
            <a :href="$trans('social_url.facebook')" target="_blank">
              <app-facebook-icon />
            </a>
            <a :href="$trans('social_url.interest')" target="_blank">
              <app-instagram-icon />
            </a>
            <a :href="$trans('social_url.pinterest')" target="_blank">
              <app-pinterest-icon />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-info">
      <div class="footer-info-language">
        <span class="footer-info-language-icon">
          <app-languages-icon />
        </span>
        <a
          href="#"
          class="footer-info-language-link"
          @click="onLocaleChange('ro_RO')"
        >
          RO
        </a>
        <span class="divider-horizontal"></span>
        <a
          href="#"
          class="footer-info-language-link"
          @click="onLocaleChange('en_US')"
        >
          EN
        </a>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-12">
            <p
              class="footer-info-text"
              v-html="$trans('footer.copyright', { year: year })"
            ></p>
            <span
              class="footer-info-project"
              v-html="$trans('app.ui.project')"
            />
          </div>
          <div class="col-lg-6 col-md-12 footer-info-images">
            <a href="https://anpc.ro/ce-este-sal/" target="_blank">
              <img
                class="card-img"
                width="223"
                height="47"
                src="~@/assets/images/logo-anpc-sal.png"
                alt="anpc-sal"
                title=""
              />
            </a>
            <a
              href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage"
              target="_blank"
            >
              <img
                class="card-img"
                width="182"
                height="46"
                src="~@/assets/images/logo-anpc-sol.png"
                alt="anpc-sol"
                title=""
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AppPhoneIcon from "@/components/ui/Icons/PhoneIcon";
import AppFacebookIcon from "@/components/ui/Icons/FacebookIcon";
import AppInstagramIcon from "@/components/ui/Icons/InstagramIcon";
import AppPinterestIcon from "@/components/ui/Icons/PinterestIcon";
import AppLanguagesIcon from "@/components/ui/Icons/LanguagesIcon";

export default {
  name: "AppFooter",
  components: {
    AppLanguagesIcon,
    AppPinterestIcon,
    AppInstagramIcon,
    AppFacebookIcon,
    AppPhoneIcon,
  },
  computed: {
    ...mapGetters("menus", ["footerMenu"]),
    ...mapGetters(["locale"]),
    year() {
      return new Date().getFullYear();
    },
  },
  methods: {
    ...mapActions(["changeLocale"]),
    getBodyPaddingRight() {
      return document.body.style["padding-right"] || 0;
    },
    onLocaleChange(locale) {
      if (this.value === locale) {
        return;
      }

      this.$emit("input", locale);
    },
    toggleMenu(event) {
      const id = event.currentTarget.id;
      if (this.isActive !== id) {
        this.isActive = id;
      } else {
        this.isActive = null;
      }
    },
  },
  data() {
    return {
      visibleFooterMenu: null,
      isActive: null,
    };
  },
  props: {
    menuItems: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
};
</script>
